import {
	DropdownMenuItem,
	DropdownMenuPortal,
	DropdownMenuSubContent
} from '@radix-ui/react-dropdown-menu'
import { GRadio } from 'components/basic-blocks/g-radio'

import { OptionSubContentProps } from '../../../context'

const options = [
	{ value: 'good', label: 'Good' },
	{ value: 'regular', label: 'Regular' },
	{ value: 'bad', label: 'Bad' }
]
const key = 'health_score'

export const HealthScore = {
	key,
	label: 'Health score',
	subContent: ({ handleSubItemChange, mapState }: OptionSubContentProps) => (
		<DropdownMenuPortal>
			<DropdownMenuSubContent
				className="bg-popover shadow-dropShadow rounded border border-gray-200 p-2"
				sideOffset={20}
				alignOffset={-9}
			>
				{options.map((o) => (
					<DropdownMenuItem key={o.value} asChild={true}>
						<GRadio
							name={o.label}
							value={o.value}
							label={o.label}
							checked={mapState.get(key) === o.value}
							onChange={(e) =>
								handleSubItemChange({ event: e, key, value: o.value })
							}
							className="p-1"
						/>
					</DropdownMenuItem>
				))}
			</DropdownMenuSubContent>
		</DropdownMenuPortal>
	)
}
